import { FONT_FAMILY } from 'styles/typography'

const themeStyles = colors => {
  const defaultStyles = {
    fontBold: {
      fontWeight: 700,
      fontSize: 14,
      marginBottom: 5,
      fontFamily: FONT_FAMILY,
      color: colors.approxBlack
    },
    fontThin: {
      fontWeight: 400,
      fontSize: 12,
      color: colors.approxBlack
    },
    positionRelative: isMobile => {
      return {
        position: 'relative',
        transform: isMobile && 'scale(0.75)'
      }
    },
    modal: {
      maxWidth: 650,
      position: 'absolute',
      top: '50%',
      left: '50%',
      margin: 0,
      transform: 'translate(-50%, -50%)'
    },
    header: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      color: colors.approxBlack,
      background: colors.white,
      borderColor: colors.pixelWhite,
      fontWeight: 400,
      fontFamily: FONT_FAMILY
    },
    patientSwitch: (style = {}) => {
      return {
        fontFamily: FONT_FAMILY,
        height: 35,
        minWidth: 150,
        borderRadius: 18,
        marginTop: 10,
        fontWeight: 700,
        padding: '0 25px',
        background: colors.primary,
        color: colors.white,
        textAlign: 'center',
        cursor: 'pointer',
        ...style
      }
    },
    content: () => {
      return {
        overflowY: 'scroll',
        background: colors.white,
        maxHeight: 210
      }
    },
    avatar: {
      height: 94,
      width: 94
    },
    drawBox: {
      height: 100,
      width: 100,
      borderRadius: '50%',
      overflow: 'hidden',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      margin: '0 auto',
      marginBottom: 10,
      borderWidth: '3px',
      borderStyle: 'solid',
      borderColor: colors.white,
      background: colors.avatarGray
    },
    curPatientData: {
      marginLeft: 20
    },
    isOnSelected: {
      borderColor: colors.primary,
      background: colors.avatarActive
    },
    dependentItem: (isOnSelected, isMobile) => {
      return {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        background: 'none',
        border: 'none',
        textAlign: 'center',
        margin: !isMobile && '0 30px',
        minWidth: 80,
        width: '100%',
        cursor: 'pointer',
        ...(isOnSelected && defaultStyles.cursorDefault)
      }
    },
    checkCircle: {
      position: 'absolute',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      background: '#12cf96',
      boxShadow: `3px 3px 5px ${colors.arcticDawn}`,
      borderRadius: '50%',
      width: 30,
      height: 30,
      padding: 5,
      fontSize: 30,
      right: 0,
      bottom: 2
    },
    checkIcon: {
      color: colors.whiteSmoke,
      transform: 'scale(0.5)',
      marginLeft: 5
    },
    closeIcon: {
      cursor: 'pointer'
    },
    cursorDefault: {
      cursor: 'default'
    },
    imgBOx: isOnSelected => {
      return {
        ...defaultStyles.drawBox,
        ...(isOnSelected && defaultStyles.isOnSelected)
      }
    },
    gridColumn: {
      minWidth: 110,
      display: 'flex',
      justifyContent: 'center'
    }
  }
  return defaultStyles
}

export default themeStyles
